<template>
  <div>
    <EditorMenuBar
      v-slot="{ commands, isActive }"
      :editor="editor"
    >
      <section>
        <el-button-group>
          <el-button
            type="info"
            size="mini"
            @click.native="commands.bold"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'bold' ]"
              fixed-width
            />
          </el-button>

          <el-button
            type="info"
            size="mini"
            @click.native="commands.italic"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'italic' ]"
              fixed-width
            />
          </el-button>

          <el-button
            type="info"
            size="mini"
            @click.native="commands.strike"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'strikethrough' ]"
              fixed-width
            />
          </el-button>

          <el-button
            type="info"
            size="mini"
            @click.native="commands.underline"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'underline' ]"
              fixed-width
            />
          </el-button>
        </el-button-group>

        <el-button-group class="ml-2">
          <el-button
            type="info"
            size="mini"
            @click.native="commands.bullet_list"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'list-ul' ]"
              fixed-width
            />
          </el-button>

          <el-button
            type="info"
            size="mini"
            @click.native="commands.ordered_list"
          >
            <FontAwesomeIcon
              :icon="[ 'far', 'list-ol' ]"
              fixed-width
            />
          </el-button>
        </el-button-group>
      </section>
    </EditorMenuBar>

    <EditorContent
      :editor="editor"
      class="border rounded border-light p-3 mt-3"
    />

    <p
      v-if="note.$fields.content.invalid"
      class="text-danger"
    >
      {{ note.$fields.content.message }}
    </p>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Bold,
  Italic,
  Strike,
  Underline,
  OrderedList,
  BulletList,
  ListItem
} from 'tiptap-extensions'
import Note from '@/plugins/sdk/resources/Note'

export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    note: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof Note
      }
    }
  },
  data () {
    return {
      editor: null
    }
  },
  created () {
    this.editor = new Editor({
      extensions: [
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new OrderedList(),
        new BulletList(),
        new ListItem()
      ],
      onUpdate: (content) => {
        this.note.content = content.getHTML()
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.editor.focus()
    })
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>
